import React from 'react';
import {ArrowDown, ArrowUp} from "../arrow/arrow";
import isItemActive from '../../utils/isItemActive'

import sectionStyles from './section.module.scss'


class Section extends React.Component {

    render() {
        const {createLink, isActive, location, onSectionTitleClick, section} = this.props;
        return (
            <div>
                <button className={isActive ? sectionStyles.sectionButtonActive : sectionStyles.sectionButton}
                        onClick={onSectionTitleClick}>
                    {isActive ? <ArrowUp/> : <ArrowDown/>}
                    {'\u00A0'}
                    {section.title}
                </button>
                <ul className={sectionStyles.sectionTitle} style={{display: isActive ? 'block' : 'none'}}>
                    {section.items && section.items.map((item, index) => (
                        <li className={sectionStyles.sectionElement} key={item.id}>
                            {createLink({
                                isActive: isItemActive(location, item),
                                item: item,
                                location,
                            })}
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default Section;
